module.exports = __webpack_public_path__ + "img/pix-logo.d120604b.svg";